require("./preGrantedCreditError.scss");
require("./preGrantedCreditError.override.scss");
// @vendor
const React = require("react");
const PropTypes = require("prop-types");
// @components
const WizardError = require("components/commons/wizardError/wizardError");
// @core
const { formatText, FormattedText } = require("core/i18n").i18n;
//@analytics
const {
    analyticsId,
    catalogue,
} = require("../analytics/preGrantedCreditAnalytics");
//@utilities
const { recordPage } = require("utilities/tagging");

const PreGrantedCreditError = (props) => {
    const errorMessage = props.title || "contractsView-errorTitle";
    const errorSubMessage = props.message || "contractsView-errorMessage";
    const errorSubMessageTranslated = (
        <FormattedText value={errorSubMessage} noWrapper />
    );

    const extraContent = props.extra ? (
        <div className="pre-granted-credit-error__extra">
            <FormattedText
                value={props.extra}
                className="pre-granted-credit-error__extra-text"
            />
        </div>
    ) : null;

    const goBackButton = {
        label: formatText(
            "contractsView-errorBackButtonLabelGlobal"
        ).toUpperCase(),
        url: "/myprofile/global",
    };

    React.useEffect(() => {
        recordPage(
            catalogue[analyticsId.PRE_GRANTED_CREDIT_WIZARD_ERROR]({
                errorMessage: errorMessage,
            })
        );
    }, []);

    return (
        <div className="pre-granted-credit-error">
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <WizardError
                    errorMessage={formatText(errorMessage)}
                    errorSubMessage={errorSubMessageTranslated}
                    mainButton={goBackButton}
                >
                    {extraContent}
                </WizardError>
            </div>
        </div>
    );
};

PreGrantedCreditError.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    extra: PropTypes.string,
};

module.exports = PreGrantedCreditError;
